import * as AWS from "aws-sdk";

const configuration = {
  region: "ap-south-1",
  secretAccessKey: "aNxVVkZLBNu3aneI85TrHI6pPyIzAFb72bDKlvXP",
  accessKeyId: "AKIAX546GMWHGDP77WX6",
};

AWS.config.update(configuration);
const s3 = new AWS.S3();

export class S3Apis {
  static getFileList = (location) => {
    return new Promise((resolve, reject) => {
      const params = {
        Bucket: "sagemakercrowdcount",
        Prefix: location,
      };

      const getAllObjects = (params, allObjects = []) => {
        s3.listObjectsV2(params, (err, data) => {
          if (err) {
            console.error("Error listing objects in S3:", err);
            reject(err);
          } else {
            const fileList = data.Contents.map((object) => object.Key);
            allObjects = allObjects.concat(fileList);

            if (data.NextContinuationToken) {
              // If there are more objects, make another request with the continuation token
              params.ContinuationToken = data.NextContinuationToken;
              getAllObjects(params, allObjects);
            } else {
              resolve(allObjects);
            }
          }
        });
      };
      getAllObjects(params);
    });
  };
}
